// src/components/store/sections/testimonials/TestimonialV34ArchportraitsTealLagoon.tsx
"use client";

import React from "react";
import DynamicTestimonialVariant from "./DynamicTestimonialVariant";

export default function TestimonialV34ArchportraitsTealLagoon(props: any) {
  return (
    <DynamicTestimonialVariant
      variantNumber={34}
      archKey="arch_portraits"
      archLabel="Cathedral Arch Portraits"
      palName="TealLagoon"
      grad="from-teal-500 via-cyan-600 to-emerald-700"
      lightBg="bg-teal-50"
      textCol="text-teal-700"
      borderCol="border-teal-200"
      btnCls="bg-teal-600 hover:bg-teal-700"
      hexCol="#14b8a6"
      {...props}
    />
  );
}
